import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { GraffitiTag } from "@/components/GraffitiTag";
import { useContent } from "@/context/ContentContext";

export const CtaBand = () => {
  const { content } = useContent();
  return (
    <section data-testid="cta-band" className="py-20 lg:py-28 px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto">
      <Reveal>
        <div className="relative border border-gold/30 bg-coal px-6 sm:px-12 py-14 sm:py-20 text-center overflow-hidden">
          <div className="hazard-gold absolute top-0 inset-x-0 h-1.5 opacity-80" />
          <div className="absolute top-0 left-0 w-14 h-14 border-t-2 border-l-2 border-gold" />
          <div className="absolute bottom-0 right-0 w-14 h-14 border-b-2 border-r-2 border-gold" />
          <p className="overline-label mb-5">Ready When You Are</p>
          <div className="relative inline-block">
            <GraffitiTag testId="cta-graffiti-tag" className="absolute -top-8 sm:-top-10 -right-2 sm:-right-10 z-10 text-xl sm:text-3xl" rotate={-5}>
              Let's Roll!
            </GraffitiTag>
            <h2 className="font-display text-3xl sm:text-5xl font-bold uppercase tracking-tight text-white max-w-3xl mx-auto leading-tight">
              Ready to Keep Your Truck <span className="gold-text">Moving?</span>
            </h2>
          </div>
          <p className="mt-5 text-sm sm:text-base text-zinc-400 max-w-xl mx-auto">
            Tell us about your operation today, or call us directly at{" "}
            <a href={`tel:${content.phone}`} className="text-champagne hover:text-gold transition-colors duration-300">{content.phone}</a>.
          </p>
          <div className="mt-10 flex flex-wrap justify-center gap-4">
            <Link to="/become-a-carrier" data-testid="cta-become-carrier-btn" className="btn-gold">Become a Carrier</Link>
            <Link to="/contact" data-testid="cta-contact-btn" className="btn-outline-gold">Request a Consultation</Link>
          </div>
        </div>
      </Reveal>
    </section>
  );
};
